import React, { useEffect } from "react";

import {truncateTitle} from "../../../middleware/truncateTitle"
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { media } from "../../../server";
import {MdKeyboardArrowDown,AiOutlineMenu} from "../../utils/icons"
import { ToggleDark,ToggleLanguages } from "../../utils";
import { BsChatLeft , } from "react-icons/bs";
import { useStateContext } from "../../../context/ContextProvider";
import { useTranslation } from "react-i18next";
import AdminProfil from "../../dashboard/utils/AdminProfil";

const NavButton = ({ title, customFunc, icon, color, dotColor }) => (
    <div content={title} position="BottomCenter">
      <button
        type="button"
        onClick={() => customFunc()}
        style={{ color }}
        className="relative text-xl rounded-full p-3 hover:bg-gray-200"
      >
        <span
          style={{ background: dotColor }}
          className="absolute inline-flex rounded-full h-2 w-2 right-2 top-2"
        />
        {icon}
      </button>
    </div>
  );

const NavItem = ({ title, customFunc, icon, color, dotColor }) => (
  <div content={title} position="BottomCenter">
    <button
      type="button"
      style={{ color }}
      className="relative text-xl rounded-full p-3 hover:bg-gray-200"
    >
      <span
        style={{ background: dotColor }}
        className="absolute inline-flex rounded-full h-2 w-2 right-2 top-2"
      />
      {icon}
    </button>
  </div>
);
function UserHeader() {
  const { user ,isAuth} = useSelector((state) => state.Users);
    const { activeMenu, setActiveMenu, handleClick, isClicked, setScreenSize, screenSize,currentColor } = useStateContext()
const {t}=useTranslation()
    useEffect(() => {
      const handleResize = () => setScreenSize(window.innerWidth);
  
      window.addEventListener('resize', handleResize);
  
      handleResize();
  
      return () => window.removeEventListener('resize', handleResize);
    }, []);
  
    useEffect(() => {
      if (screenSize <= 900) {
        setActiveMenu(false);
      } else {
        setActiveMenu(true);
      }
    }, [screenSize]);
  
    const handleActiveMenu = () => setActiveMenu(!activeMenu);
  
  return (
    <div className="fixed md:static navbar   bg-gradient-to-b from-color-5 to-color-6 dark:bg-gradient-to-b dark:from-color-9 dark:to-color-10  backdrop-blur-2xl  border border-b-1 border-t-0  border-[#ffffff1a] shadow-md   w-full ">
    <div className="flex justify-between navbar  max-h-16 p-2 md:ml-6 md:mr-6 relative">

      <div className="flex">
     
        <NavButton title="Menu" customFunc={handleActiveMenu} color={currentColor} icon={<AiOutlineMenu size={25}/>} />
      </div>
  
      <div className="flex w-full items-center">
        <div className="flex w-full justify-between items-center mr-4">
          <div className=" flex flex-row justify-center gap-5">    <ToggleDark />
          <ToggleLanguages /></div>
      
         
        
     
       
          <div className="lg:block hidden">
          <NavButton title="Chat" dotColor="#03C9D7" customFunc={() => handleClick('chat')} color={currentColor} icon={<BsChatLeft />} />

          </div>
          <div content="Profile" position="BottomCenter">
          <div
            className="flex items-center gap-2 cursor-pointer p-1 hover:bg-gray-200 rounded-lg"
            onClick={() => handleClick('userProfile')}
          >
            <img
              className="rounded-full object-cover w-8 h-8"
              src={`${media}${user?.avatar}`}
              alt="user-profile"
            />
            <p>
              <span className="text-gray-400 font-kufi text-14">{t("Hi,")}</span>{' '}
              <span className="text-gray-400 font-bold font-kufi ml-1 text-md">
          {truncateTitle(user?.name, 1)}
              </span>
            </p>
            <MdKeyboardArrowDown className="text-gray-400 text-14" />
          </div>
        </div>
       
        </div>
      </div>
      {/*isClicked.chat && (<Chat />)*/}
   {isClicked.userProfile && (<AdminProfil />)}
    </div>
    </div>
  );
};

export default UserHeader